import React, { useEffect, useState } from "react";
import { Row, Col, FormGroup, Label, Input } from "reactstrap";
import { connect } from "react-redux";
import { updateCreateParams } from "../../../actions/create";

export const FifthStep = (props) => {
  const [projectSelect, setProjectSelect] = useState("");
  const [projectCreate, setProjectCreate] = useState("");

  useEffect(() => {
    if (props.project !== "") {
      if (props.projects.includes(props.project)) {
        setProjectSelect(props.project);
      } else {
        setProjectCreate(props.project);
      }
    }
  }, []);

  return (
    <div style={{ padding: "20px 10px" }}>
      <FormGroup>
        <Label for="label">Assign a short label (max 20 char)</Label>
        <Input
          type="text"
          name="label"
          id="label"
          value={props.label}
          onChange={(e) =>
            props.updateCreateParams(e.target.name, e.target.value)
          }
          style={{ width: 250 }}
          maxLength="20"
        />
      </FormGroup>
      <Row style={{ marginTop: 30 }}>
        <Col lg="3" md="12">
          <Label for="projectSelect">Choose a project</Label>
          <Input
            type="select"
            name="projectSelect"
            id="projectSelect"
            style={{ width: 250 }}
            onChange={(e) => {
              setProjectSelect(e.target.value);
              setProjectCreate("");
              props.updateCreateParams("project", e.target.value);
            }}
            value={projectSelect}
          >
            <option value="" disabled={true}></option>
            {props.projects.map((p) => (
              <option key={p} value={p}>
                {p}
              </option>
            ))}
          </Input>
        </Col>
        <Col lg="9" md="12" style={{ marginTop: 2 }}>
          <Label for="projectCreate">Or create a new one</Label>
          <Input
            type="text"
            name="projectCreate"
            id="projectCreate"
            style={{ width: 250 }}
            onChange={(e) => {
              setProjectCreate(e.target.value);
              setProjectSelect("");
              props.updateCreateParams("project", e.target.value);
            }}
            value={projectCreate}
          ></Input>
        </Col>
      </Row>

      <FormGroup style={{ marginTop: 30, marginBottom: "-20px" }}>
        <Label for="description">Assign a description (optional)</Label>
        <Input
          type="textarea"
          name="description"
          id="description"
          value={props.description}
          onChange={(e) =>
            props.updateCreateParams(e.target.name, e.target.value)
          }
        />
      </FormGroup>
    </div>
  );
};

const mapStateToProps = (state) => ({
  label: state.create.label,
  description: state.create.description,
  project: state.create.project,
  projects: state.cases.projects,
});

export default connect(mapStateToProps, { updateCreateParams })(FifthStep);
